import React from "react";
import { MdCheck, MdRemove } from "react-icons/md";

// aria-disabled instead of disabled keeps keyboard focus on the toggle while it saves.
const CarrierToggle = ({ checked, onChange, disabled = false, label }) => (
  <button
    type="button"
    role="switch"
    aria-checked={checked}
    aria-label={label}
    aria-disabled={disabled || undefined}
    onClick={() => !disabled && onChange(!checked)}
    className={`relative block h-[38px] w-[58px] shrink-0 ${disabled ? "cursor-wait opacity-60" : ""}`}
  >
    <span
      className={`absolute left-2 top-2 h-[22px] w-[42px] rounded-full transition-all ${
        checked ? "bg-brand opacity-50" : "bg-ui-text-subtle"
      }`}
    />
    <MdCheck className="absolute left-[13px] top-[11px] h-4 w-4 text-white" />
    <MdRemove className="absolute right-[13px] top-[11px] h-4 w-4 text-white" />
    <span
      className={`absolute top-[11px] h-4 w-4 rounded-full transition-all ${
        checked ? "left-[31px] bg-brand" : "left-[11px] bg-white"
      }`}
    />
  </button>
);

export default CarrierToggle;
